const circlePrimaryButtonStyles = theme => ({
  '.btn-circle-primary': {
    backgroundColor: theme('colors.green1.55'),
    color: theme('colors.white'),
    border: 'none',
    'a&:hover, a&:focus': {
      color: theme('colors.white'),
    },
    '&:hover, &:focus': {
      backgroundColor: theme('colors.green1.60'),
    },
    '&:active': {
      backgroundColor: theme('colors.green1.65'),
    },
    '&.disabled': {
      backgroundColor: theme('colors.green1.30'),
    },
  },

  '.btn-circle-primary-emphasis': {
    backgroundColor: theme('colors.orange1.23'),
    color: theme('colors.black'),
    border: `1px solid ${theme('colors.orange1.30')}`,
    'a&:hover, a&:focus': {
      color: theme('colors.black'),
    },
    '&:hover, &:focus': {
      backgroundColor: theme('colors.orange1.25'),
    },

    '&:active': {
      backgroundColor: theme('colors.orange1.30'),
    },

    '&.disabled': {
      backgroundColor: theme('colors.orange1.15'),
      borderColor: theme('colors.orange1.15'),
      color: theme('colors.grey.40'),
    },
  },

  '.btn-circle-primary-light': {
    backgroundColor: theme('colors.green1.10'),
    color: theme('colors.green1.60'),
    border: 'none',
    'a&:hover, a&:focus': {
      color: theme('colors.green1.60'),
    },
    '&:hover, &:focus': {
      backgroundColor: theme('colors.green1.15'),
    },
    '&:active': {
      backgroundColor: theme('colors.green1.20'),
    },
    '&.disabled': {
      backgroundColor: theme('colors.green1.40'),
      color: theme('colors.green1.20'),
    },
  },
});

module.exports = { circlePrimaryButtonStyles };
